import {
  DesignSystem,
  Login,
  ForgotPassword,
  DataGroup,
  DataProyek,
  DataMyTeam,
  DataPostinganReport,
} from "../container/pages";
import Dashboard from "../container/pages/Dashboard";
import DataLoker from "../container/pages/DataLoker";
import Notifikasi from "../container/pages/Notifikasi";
import DataPostingan from "../container/pages/DataPostingan";
import DataTiket from "../container/pages/DataTiket";
import DataPengguna from "../container/pages/DataPengguna";
import LoginMyTeam from "../container/pages/LoginMyTeam";
import PengaturanPengguna from "../container/pages/PengaturanPengguna";
import PengaturanWeb from "../container/pages/PengaturanWeb";
import LokerFormPublic from "../container/pages/LokerFormPublic";
import Banner from "../container/pages/Banner";
import FormulirEditLoker from "../container/pages/DataLoker/FormulirEditLoker";

export const DesignSystemRoutes = [
  {
    id: 1,
    path: "/design-system",
    component: DesignSystem,
    exact: true,
  },
];

export const LokerPublic = [
  {
    id: 1,
    path: "/loker",
    component: LokerFormPublic,
    exact: true,
  },
];

export const User = [
  {
    id: 1,
    nameComponent: "Data My Team",
    path: "/nakerweb/my-team",
    component: DataMyTeam,
    exact: true,
  },
];

export const BeforeLogin = [
  {
    id: 1,
    path: "/nakerweb/login",
    component: Login,
    exact: true,
  },
  {
    id: 2,
    path: "/nakerweb/forgot-password",
    component: ForgotPassword,
    exact: true,
  },
  {
    id: 3,
    path: "/nakerweb/login-myteam",
    component: LoginMyTeam,
    exact: true,
  },
];

const AppRoutes = [
  {
    id: 1,
    nameComponent: "Dasboard",
    path: "/nakerweb/dashboard",
    component: Dashboard,
    menuName: "Dashboard",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 2,
    nameComponent: "Data Pengguna",
    path: "/nakerweb/data-pengguna",
    component: DataPengguna,
    menuName: "Data Pengguna",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 3,
    nameComponent: "Data Grup",
    path: "/nakerweb/data-grup",
    component: DataGroup,
    menuName: "Data Grup",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 4,
    nameComponent: "Data Loker",
    path: "/nakerweb/data-loker",
    component: DataLoker,
    menuName: "Data Loker",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 5,
    nameComponent: "Data Proyek",
    path: "/nakerweb/data-proyek",
    component: DataProyek,
    menuName: "Data Proyek",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 6,
    nameComponent: "Data Postingan",
    path: "/nakerweb/data-postingan",
    component: null,
    menuName: "Data Postingan",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 7,
    nameComponent: "Update Data Loker",
    path: "/nakerweb/data-loker/:loker_id",
    component: FormulirEditLoker,
    menuName: "Data Loker",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 601,
    nameComponent: "Postingan",
    path: "/nakerweb/postingan",
    component: DataPostingan,
    menuName: "Data Postingan",
    exact: true,
    parentId: 6,
    expand: false,
  },
  {
    id: 602,
    nameComponent: "Dilaporkan",
    path: "/nakerweb/postingan-report",
    component: DataPostinganReport,
    menuName: "Data Postingan",
    exact: true,
    parentId: 6,
    expand: false,
  },
  {
    id: 12,
    nameComponent: "Data Tiket",
    path: "/nakerweb/data-tiket",
    component: DataTiket,
    menuName: "",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 10,
    nameComponent: "Broadcast",
    path: "/nakerweb/notifikasi",
    component: Notifikasi,
    menuName: "BroadCast",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 13,
    nameComponent: "Banner",
    path: "/nakerweb/banner",
    component: Banner,
    menuName: "Banner",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 11,
    nameComponent: "Pengaturan",
    path: "/nakerweb/pengaturan",
    component: null,
    menuName: "Pengaturan",
    exact: true,
    parentId: 0,
    expand: false,
  },
  {
    id: 111,
    nameComponent: "Pengguna",
    path: "/nakerweb/pengaturan/pengguna",
    component: PengaturanPengguna,
    menuName: "Pengguna",
    exact: true,
    parentId: 11,
    expand: false,
  },
  {
    id: 112,
    nameComponent: "Web",
    path: "/nakerweb/pengaturan/web",
    component: PengaturanWeb,
    menuName: "Web",
    exact: true,
    parentId: 11,
    expand: false,
  },
];

export default AppRoutes;
